<template>
 <div class="conversion-box">
   <div class="conversion">
    <div class="top">
      
      <el-form :model="formData" @submit.native.prevent label-width="70px" label-position="left"> 
        <el-form-item label="添加方式">
          <listCheck 
            v-model="formData.addType"
            :list="typeList"
            :before-change="handleAddTypeBeforeChange"
          />
        </el-form-item>
        <el-form-item label="产品" required v-if="formData.addType === 2">
          <listCheck 
            v-model="formData.product"
            :list="productList"
            label="转化出价"
            @change="handleProductChange"
          />
        </el-form-item>
       <el-form-item label="版位" required>
          <listCheck 
            v-model="formData.position"
            :base="formData.addType ===1?productList.length:1"
            :list="positionList"
            label="转化出价"
          />
        </el-form-item>
      </el-form>
      <div class="tip">
        <svg-icon icon-class='tip' class-name='tip-icon' />
        您可在转化名称中输入一个不存在的转化名称，点击创建按钮，快速创建对应的转化跟踪。若聚投未显示媒体中全部的转化名称，您可点击更新按钮进行获取
        <UpdateTimeButton 
          type="primary" 
          plain 
          :date="updateTime"
          size="mini"
          @click="handleUpdateNameList"
       />
      </div>
      <el-button type="primary" size="mini" @click="handleAddFormClick">+添加出价</el-button>
    </div>
    <div class="form-box" 
      id="infinite-form-box"
      v-loading="loading"
      v-infinite-scroll="handleLoadItemData"
      :infinite-scroll-distance="20"
    >
      <template v-if="!loading">
        <template v-for="(item, index) in formList">
          <conversionForm 
            :key="item.id+formParams" :formData="item"
            :ref="item.id"
            :targetList="targetList"
            :addType='formData.addType'
            @updateFormNum="handleUpdateFormNum"
            @copyFormData="handleCopyFormData"
            :index='index+1'
          />
        </template>
      </template>
    </div>
    <div class="footer">
      <el-button @click="handleCloseClick">取消</el-button>
      <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit" :loading="saveLoaing">保存</el-button>
    </div>
  </div>
 </div>
</template>

<script>
import listCheck from './listCheck.vue'
// import SvgIcon from "@/components/SvgIcon";
import conversionForm from './conversionForm.vue';
import { validNum } from '@/utils/validate'
import util from '@/libs/utils'
import { isEqual, cloneDeep } from 'lodash'
import { InfiniteScroll } from 'element-ui'
import API from '@/api/marketManage/miBatch'
import { tipModal } from '../index'
import UpdateTimeButton from '@/components/UpdateTimeButton'
const defaultSliceLength = 6;
const defaultFormData = {
  follType: '',
  convType: '',
  price_1: 0.1,
  price_2: '',
  target: '转化',
  name: '',
  deepConv: '0'
}
export default {
  props: [ 'cbs', 'displayType', 'appList', 'defaultFormObj', 'account', 'configOpt', 'addType' ],
  components: { listCheck, conversionForm, UpdateTimeButton },
  directives: { InfiniteScroll },
  provide() {
    return {
      getTypeData: (...arg)=> this.getConversionDataList(...arg),
      getTrackingType: ()=> this.trackingTypeList,
      getFormParams: ()=>{
        return {
          account_id: this.account,
          app_id: this.formData.product,
          display_type: this.formData.position
        }
      },
      getPackageType: ()=>this.packageType,
      appList: this.productList,

    }
  },
  data() {
    const { defaultFormObj, addType } = this;
    
    const { billing_type } = this.configOpt
    let  positionId = '',productId=''; 
    let positionList = this.displayType.map((v, i)=> {
      i===0&&(positionId=v.param_id);
      return {
        ...v,
        label: v.param_name,
        value: v.param_id,
        num: 0
      }
    });
    let config = {};
    let productList = this.appList.map((v, i)=> {
      i===0&&(productId=v.app_id);
      return {
        ...v,
        label: `${v.app_name}(${v.app_id})`,
        value: v.app_id,
        num: 0
      }
    });
    productList.forEach((v, i)=>{
      let num = 0;
      positionList.forEach(item=> {
        const key = `${v.value}_${item.value}`;
        config[key] = defaultFormObj[key].length? defaultFormObj[key].map(v=> {
          return {
            ...v,
            deepConv:  'deepConv' in v? v.deepConv : '0' ,
            id: util.randomString(20)
          }
        }) : [{ id: util.randomString(20),...defaultFormData}];
        let n = (defaultFormObj[key].length || 1);
        num+=n;
        if (i ===0) {
          item.num = n
        }
      });
      v.num = num;
    });
    return {
      updateTime: 0,
      jsonDefaultFormData: defaultFormObj,//默认的JSON串
      billingType: billing_type,
      preFormData:[],
      config,
      productList,
      positionList,
      formData: {
        product:  productId,
        position: positionId,
        addType
      },
      typeList: [
        {
          label: '按版位',
          value: 1
        },
        {
          label: '按产品+版位',
          value: 2
        },
      ],
      formList: [],
      // 滚动更新的数据
      hideFormListData: [],
      trackingTypeList: [],//跟踪类型
      loading: false,
      saveLoaing: false,
      axjxDataCb: {},
    }
  },
  computed: {
    formParams() {
      const { product, position } = this.formData
      return `${product}_${position}`
    },
    packageType() {
      const { product } = this.formData
     const data = this.productList.find(v=> v.app_id === product);
     return data.package_type;
    },
    // 竞价目标
    targetList() {
      const { position } = this.formData;
      const list = this.billingType.filter(v=>v.pid ===position).map(v=> {
        return {
          ...v,
          value: v.param_name,
          label: v.param_name
        }
      });
      return list;
    }
  },
  watch: {
    formParams: {
      handler(n, o){
        this.updateConfigData(o);
        // 切换数据后滚动到顶部
        const dom = document.querySelector('#infinite-form-box');
        if (dom) {
          dom.scrollTop = 0;
        };
        const arr = [...this.config[n]]
        this.formList = [...arr.slice(0,defaultSliceLength)]
        this.hideFormListData = [...arr.slice(defaultSliceLength, arr.length)];
      },
      immediate: true
    }
  },
  created() {
    this.loading = true
    this.getConversionDataList(({ tracking_type })=> {
      this.trackingTypeList = tracking_type;
      this.loading = false
    })
  },
 methods: {
  // 添加方式切换
  handleAddTypeBeforeChange(value, cb) {
    this.$confirm('切换后已经修改的内容不会保存，确认要切换吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      Object.keys(this.config).map(v=> {
        this.config[v] = [  { ...defaultFormData,  id: util.randomString(20)  } ]
      })
      this.formList = [ { ...defaultFormData,  id: util.randomString(20)  }];
      this.hideFormListData = [];
      this.productList = this.productList.map(v=> {
        return {
          ...v,
          num: this.positionList.length
        }
      });
      this.positionList = this.positionList.map(v=> {
        return {
          ...v,
          num: 1
        }
      })
      cb()
    }).catch(() => {});
   
  },
  getConversionDataList(cb, params ={} ) {
    const p = JSON.stringify(params);
    const ls = this.axjxDataCb[p]
    if (ls) {
      ls.push(cb);
      return;
    }else {
      this.axjxDataCb[p] = [ cb ]
    };
    const { position } = this.formData
    params.display_type = position;
    
    if (params.app_id) {
      API.getConversionNameDataList(params).then(res=> {
        this.axjxDataCb[p].map(v=> {
          v( { conversion_name: res.data } )
        })
      }).catch(()=> {
        this.axjxDataCb[p].map(v=> {
          v([])
        })
      }).finally(()=> {
        this.axjxDataCb[p] = undefined
      })
    }else {
      API.getConversionDataList(params).then(res=> {
        this.axjxDataCb[p].map(v=> {
          v(res.data)
        })
      }).catch(()=> {
        this.axjxDataCb[p].map(v=> {
          v([])
        })
      }).finally(()=> {
        this.axjxDataCb[p] = undefined
      })
    }
    
  },
  // 更新元数据
  updateConfigData(key) {
    key = key || this.formParams;
    // 初次渲染的时候不更新数据
    if (this.formList.length ===0) return;
    if (this.formData.addType === 1) {
      const [ product, position ] = key.split('_');
      this.productList.map(v=> {
        this.updateFn(`${v.app_id}_${position}`, v.app_id)
      })
    }else {
      const [app_id] = key.split('_');
      this.updateFn(key, app_id)
    }
  },
  updateFn(key, appid) {
    const { addType, position } = this.formData;
    const nameDataObj = {};
    const deepNameDataObj = {};
    this.config[key] = this.formList.map(v=> {
      // 提前更新form数据
      const data = this.$refs[v.id][0].updateData();
      const nameData = data.nameData;
      const deepNameData = data.deepNameData;
      const { follType, convType, convTarget } = v
      if (addType===1&&nameData) {
        data.name = nameData[appid] || v.name;
        nameDataObj[`${follType}_${convType}`] = nameData[appid];
        delete data.nameData;
      }
      if (addType===1&&deepNameData) {
        data.deepName = deepNameData[appid] || v.deepName;
        deepNameDataObj[`${follType}_${convType}_${convTarget}`] = deepNameData[appid];
        delete data.deepNameData;
      }
      
      return cloneDeep(data);
    })
    if (this.hideFormListData.length>0) {
      this.config[key].push(...this.hideFormListData.map(v=> {
        const { follType, convType, convTarget } = v
        return {
          ...v,
          name: nameDataObj[`${follType}_${convType}`] || v.name,
          deepName: deepNameDataObj[`${follType}_${convType}_${convTarget}`] || v.deepName,
        }
      }))
    }
  },
  // 切换产品
  handleProductChange() {
    this.$nextTick(()=> {
      const { product } = this.formData
      this.positionList.map(v=> {
        v.num = this.config[`${product}_${v.value}`].length
      })
    })
  },
  // 添加
   handleAddFormClick() {
    const data = {
        id: util.randomString(20),
        ...defaultFormData
      }
    if (this.hideFormListData.length>0) {
      this.hideFormListData.push(data)
    }else {
      this.formList.push(data)
    }
    this.updateFormNum(1)
  },
   // 更新数量数据
  updateFormNum(num) {
    if (this.formData.addType === 1) {
      this.productList.map(v=> {
        v.num +=num;
      })
    }else {
      const pro = this.productList.find(v=> {
        return v.value === this.formData.product
      });
       pro.num +=num;
    }
     const pos = this.positionList.find(v=> {
      return v.value === this.formData.position
    });
    pos.num +=num;
  },
//  删除
  handleUpdateFormNum(id) {
    if (this.formList.length ===1) {
      this.$message.warning('最少需添加一个转化出价')
      return;
    }
    const i = this.formList.findIndex(v=> v.id===id);
    this.formList.splice(i, 1);
    if (this.hideFormListData.length) {
      this.formList.push(this.hideFormListData.shift())
    }
    this.updateFormNum(-1)
  },
  // copy 表单
  handleCopyFormData(data) {
    // const index = this.formList.findIndex(v=> {
    //   return v.id === data.id;
    // });
    // this.formList.splice(index, 0, {
    //   ...data,
    //   id: util.randomString(20)
    // });
    const form = {
        ...data,
        id: util.randomString(20)
      }
    if (this.hideFormListData.length>0) {
      this.hideFormListData.push(form);
      this.formList.push(this.hideFormListData.shift())
    }else {
      this.formList.push(form)
    }
    this.updateFormNum(1)
  },
  handleLoadItemData() {
     if (this.hideFormListData.length === 0||this.loading) {
      return;
     }
    this.formList.push(...this.hideFormListData.splice(0, 3))
  },
  onSubmit() {
    this.updateConfigData();
    
    this.saveLoaing = true;
    const proObj = this.productList.reduce((pre, item)=> {
      pre[item.app_id] = item.app_name;
      return pre;
    }, {});
    const posObj = this.positionList.reduce((pre, item)=> {
      pre[item.param_id] = item.param_name;
      return pre;
    }, {});
    let validEmptyData ={}
    let validSameData ={}
    let validNumData ={}
    let validNumBigData ={}
    let validDeepNumBigData ={}
    Object.keys(this.config).forEach(v=> {
      const list = this.config[v];
      const [ app_id, display_type ] = v.split("_")
      const strObj = {}
      list.map(item=> {
        const { follType,convType, price_1, price_2, target, name, 
          deepName, deep_price,  deepConv, convTarget
        } = item;
        const l = proObj[app_id] ;
        const p = posObj[display_type];
         // 验证转化必填
        if (target === '转化') {
          if (!follType || !convType || !price_1 || !price_2|| !name || (deepConv === '1' &&(!deepName || !deep_price || !convTarget))) {
            if (validEmptyData[l]) {
              validEmptyData[l].push(p)
            }else {
               validEmptyData[l] = [p]
            }
          }else {
            if (deepConv ==='1') {
              if (!validNum(deep_price) || !(0.01<=deep_price&&deep_price<100) ) {
                if (validDeepNumBigData[l]) {
                  validDeepNumBigData[l].push(p)
                }else {
                  validDeepNumBigData[l] = [p]
                }
              }
            }
            if (!validNum(price_1)||!validNum(price_2) || !(0.01<=price_2&&price_2<5000&&0.01<=price_1&&price_1<5000) ) {
              if (validNumData[l]) {
                validNumData[l].push(p)
              }else {
                validNumData[l] = [p]
              }
            }else {
              if (+price_1>=+price_2) {
                if (validNumBigData[l]) {
                  validNumBigData[l].push(p)
                }else {
                  validNumBigData[l] = [p]
                }
              }
            }
          }
          // 其他必填
        }else {
           if (!price_1) {
            if (validEmptyData[l]) {
              validEmptyData[l].push(p)
            }else {
               validEmptyData[l] = [p]
            }
          }else {
            if (!validNum(price_1) || !(0.01<=price_1&&price_1<5000) ) {
              if (validNumData[l]) {
                validNumData[l].push(p)
              }else {
                validNumData[l] = [p]
              }
            }
          }
        };
        // 验证是否有相同数据
        const valueStr = this.toJsonData(item);
        if (strObj[valueStr]) {
          if (validSameData[l]) {
            validSameData[l].push(p)
          }else {
              validSameData[l] = [p]
          }
        }else {
          strObj[valueStr] = true
        }
      });
      
    })
    if (Object.keys(validEmptyData).length>0) {
      console.log(validEmptyData, 'validEmptyData');
      
      this.saveLoaing = false;
      this.showTip('存在必填项为空的转化出价，请检查，具体如下：', validEmptyData)
      return;
    }
     if (Object.keys(validNumData).length>0) {
      this.saveLoaing = false;
      this.showTip('出价不可小于0.01大于等于5000，请检查，具体如下：', validNumData)
      return;
    }
    if (Object.keys(validDeepNumBigData).length>0) {
      this.saveLoaing = false;
      this.showTip('出价不可小于0.01大于等于100，请检查，具体如下：', validDeepNumBigData)
      return;
    }
    
    if (Object.keys(validSameData).length>0) {
       this.saveLoaing = false;
      this.showTip('存在相同的转化出价，请检查，具体如下：', validSameData)
      return;
    }
    if (Object.keys(validNumBigData).length>0) {
      this.saveLoaing = false;
      this.showTip('二阶出价需大于一阶出价，请检查，具体如下：', validNumBigData)
      return;
    }
    this.saveLoaing = false;
    this.cbs.onSubmit({
      data: {
        ...this.config
      },
      addType: this.formData.addType
    })
  },
  // 提示弹框
  showTip(tip, list) {
    if (this.formData.addType === 1) {
      const data = Object.values(list).reduce((pre, item)=> {
        pre.push(...item)
        return pre
      }, []);
      list = {
        '': data
      }
    }
     tipModal({
      props: {
        tip,
        list
      },
     })
  },
  // 关闭逻辑
  handleCloseClick() {
    this.updateConfigData();
    if (!isEqual(JSON.parse(this.toJsonData(this.defaultFormObj)), JSON.parse(this.toJsonData(this.config))) ) {
        this.$confirm('取消后已经修改的内容不会保存，确认要取消吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
          this.$emit('close')
          }).catch(() => {});
      }else {
        this.$emit('close')
      }
  },
  toJsonData(data) {
    const json = JSON.stringify(data, (key,v)=>{
      if (key ==='id' || (this.formData.addType === 1 && key ==='name')) {
        return undefined
      }else{ 
        return v;
      }
    });
    return json;
  },
  async handleUpdateNameList() {
     const vm = this.$notify({
        title: '请求成功',
        message: '正在更新，请稍等',
        type: 'success'
      });
    const params = {
      account_id: this.account
    }
    try {
      await API.postUpdateConversion(params);
      this.$bus.$emit('updateName')
       this.$notify({
        title: '更新成功',
        message: '转化跟踪 更新成功',
        type: 'success'
      });
    } catch (error) {
      if (typeof error.data === "number" && error.data>0) {
        this.updateTime = error.data;
      }
       this.$notify({
        title: '更新失败',
        message: error.info || '转化跟踪 更新失败',
        type: 'error'
      });
      console.log('转化跟踪更新失败',error);
    }
     if (vm) {
      vm.close()
    }
  }
 }
}
</script>

<style lang="scss" scoped>
.tip-icon {
  font-size: 18px;
  margin-right: 4px;
}
.conversion-box {
  height: 100%;
  width: 100%;
  overflow-x: auto;
}
.conversion {
  padding: 0 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 1200px;
  .tip {
    margin-bottom: 10px;
  }
  .form-box {
    height: 0;
    flex: 1;
    overflow: auto;
    // background: red;
    margin-top: 16px;
  }
  .footer {
    height: 60px;
    line-height: 60px;
    text-align: right;
    padding-right: 80px;
    margin: 0 -20px;
    box-shadow: 4px 0 4px #ccc;
  }
}

</style>